import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-charcoal-dark text-white/60 py-10 text-center text-sm px-6" data-id="element-32">
        <div className="max-w-4xl mx-auto space-y-4" data-id="element-33">
          <p data-id="element-34">
            Este producto no sustituye el consejo médico profesional. Los
            resultados pueden variar de persona a persona.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-35">
            <button onClick={() => setActiveModal('privacy')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-36">
              Política de Privacidad
            </button>
            <span className="text-white/30" data-id="element-37">|</span>
            <button onClick={() => setActiveModal('terms')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-38">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-white/40" data-id="element-39">
            &copy; {new Date().getFullYear()} Protocolo Vientre Plano 40+. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-40">
          <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-41">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-8 py-5 border-b border-gray-100 bg-cream" data-id="element-42">
              <h2 className="text-xl font-bold text-charcoal-dark font-playfair" data-id="element-43">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-sage-light/30 transition-colors text-charcoal-light hover:text-charcoal-dark" aria-label="Cerrar" data-id="element-44">
                <XIcon className="w-5 h-5" data-id="element-45" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="px-8 py-6 overflow-y-auto max-h-[calc(85vh-80px)] text-charcoal-light leading-relaxed space-y-4 text-sm" data-id="element-46">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-47" /> : <TermsContent data-id="element-48" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-charcoal-dark font-semibold text-base" data-id="element-49">
        Última actualización: Marzo 2026
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-50">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-51">
        Recopilamos información personal que nos proporcionas voluntariamente al
        realizar una compra, incluyendo: nombre, dirección de correo electrónico
        e información de pago. No almacenamos datos de tarjetas de crédito
        directamente; estos son procesados de forma segura por nuestros
        proveedores de pago certificados.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-52">
        2. Uso de la Información
      </h3>
      <p data-id="element-53">Utilizamos tu información personal para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-54">
        <li data-id="element-55">Procesar y entregar tu compra digital.</li>
        <li data-id="element-56">Enviarte el acceso al producto y actualizaciones relacionadas.</li>
        <li data-id="element-57">Responder a tus consultas o solicitudes de soporte.</li>
        <li data-id="element-58">Mejorar nuestros productos y servicios.</li>
      </ul>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-59">
        3. Protección de Datos
      </h3>
      <p data-id="element-60">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración. Todas las transacciones se realizan con encriptación SSL de
        256 bits.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-61">
        4. Compartir Información
      </h3>
      <p data-id="element-62">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a proveedores de servicios de confianza que nos
        asisten en la operación de nuestro sitio web y procesamiento de pagos,
        siempre que dichas partes acuerden mantener esta información
        confidencial.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-63">
        5. Cookies
      </h3>
      <p data-id="element-64">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies, aunque esto podría afectar algunas
        funcionalidades.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-65">
        6. Tus Derechos
      </h3>
      <p data-id="element-66">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, contáctanos a través
        de los canales proporcionados en nuestro sitio.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-67">
        7. Cambios a esta Política
      </h3>
      <p data-id="element-68">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-charcoal-dark font-semibold text-base" data-id="element-69">
        Última actualización: Marzo 2026
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-70">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-71">
        Al acceder y utilizar este sitio web y adquirir el producto "Protocolo
        Vientre Plano 40+", aceptas estar sujeta a estos términos y condiciones.
        Si no estás de acuerdo con alguno de estos términos, te pedimos que no
        realices la compra.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-72">
        2. Naturaleza del Producto
      </h3>
      <p data-id="element-73">
        "Protocolo Vientre Plano 40+" es un producto digital de carácter
        informativo y educativo. No constituye consejo médico, diagnóstico ni
        tratamiento. Siempre consulta con un profesional de la salud antes de
        iniciar cualquier programa de alimentación o ejercicio.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-74">
        3. Entrega del Producto
      </h3>
      <p data-id="element-75">
        Al completar tu compra, recibirás acceso inmediato al contenido digital.
        El producto se entrega exclusivamente en formato digital y no se envía
        ningún material físico.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-76">
        4. Resultados
      </h3>
      <p data-id="element-77">
        Los resultados descritos en esta página son ejemplos y pueden variar de
        persona a persona. No garantizamos resultados específicos, ya que estos
        dependen de factores individuales como la adherencia al programa,
        condiciones de salud preexistentes y otros factores personales.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-78">
        5. Propiedad Intelectual
      </h3>
      <p data-id="element-79">
        Todo el contenido del producto, incluyendo textos, gráficos, guías y
        materiales, está protegido por derechos de autor. Queda prohibida la
        reproducción, distribución o reventa del contenido sin autorización
        expresa por escrito.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-80">
        6. Política de Reembolso
      </h3>
      <p data-id="element-81">
        Debido a la naturaleza digital e inmediata del producto, todas las
        ventas son finales. Sin embargo, si experimentas problemas técnicos para
        acceder al contenido, contáctanos y resolveremos tu situación.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-82">
        7. Limitación de Responsabilidad
      </h3>
      <p data-id="element-83">
        En ningún caso seremos responsables por daños directos, indirectos,
        incidentales o consecuentes que resulten del uso o la imposibilidad de
        uso del producto. El uso del contenido es bajo tu propia
        responsabilidad.
      </p>

      <h3 className="font-bold text-charcoal-dark text-base mt-6" data-id="element-84">
        8. Modificaciones
      </h3>
      <p data-id="element-85">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en esta página.
      </p>
    </>;
}